(function filterButtonList() {
    var activeClassName = "secondary";
    var inactiveClassName = "tertiary-grey";
    var filterButtons = document.querySelectorAll(".filter-button");
    var tagSections = document.querySelectorAll(".row[data-filter-tag]");

    if (filterButtons.length > 0) {
        for (var i = 0; i < filterButtons.length; i++) {

            var filterButton = filterButtons[i];
            if (filterButton) {
                filterButton.addEventListener("click", handleFilterButtonClick, false);
            }
        }

        setDefaultFilter();
    }

    function handleFilterButtonClick(e) {
        e.preventDefault();
        var button = this.children[0];
        var isActive = button.classList.contains(activeClassName);
        var hrefAttribute = button.getAttribute("href");


        if (isActive) {
            return;
        } else {
            toggleActiveState(button);

            if (button.dataset.tag === "*") {
                showAll();
            } else {
                filterByTag(button.dataset.tag);
            }

            if (hrefAttribute) {
                updateHistory(hrefAttribute);
            }
        }
    }

    function showAll() {
        for (var i = 0; i < tagSections.length; i++) {
            var tagSection = tagSections[i];
            tagSection.classList.remove("filter-tag-hidden");
        }
    }

    function filterByTag(tagName) {
        for (var i = 0; i < tagSections.length; i++) {
            var tagSection = tagSections[i];

            tagSection.classList.add("filter-tag-hidden");

            if (tagName === tagSection.dataset.filterTag) {
                tagSection.classList.remove("filter-tag-hidden");
            }
        }
    }

    function updateHistory(path) {
        if (!path) {
            return;
        }

        if (history.pushState) {
            var url = window.location.protocol + "//" + window.location.host + window.location.pathname + path;
            window.history.pushState({ path: url }, "", url);
        }
    }

    function toggleActiveState(element) {
        for (var i = 0; i < filterButtons.length; i++) {
            var childElement = filterButtons[i].children[0];

            if (childElement) {
                childElement.classList.remove(activeClassName);
                childElement.classList.add(inactiveClassName);
            }
        }

        element.classList.remove(inactiveClassName);
        element.classList.add(activeClassName);
    }

    function getParameterByName(name, url) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    function setDefaultFilter() {
        var buttonElement;
        var tagName = getParameterByName("tag");

        if (!tagName) {
            if (filterButtons.length > 0) {
                buttonElement = filterButtons[0].children[0];
                tagName = buttonElement.dataset.tag;
            }
        } else {
            buttonElement = document.querySelector("[data-tag=\"" + tagName + "\"]");
        }

        if (buttonElement) {
            toggleActiveState(buttonElement);
            filterByTag(tagName);
        }
    }
})();